import { useEffect, useState } from 'react';

const DISMISS_KEY = 'shopik_app_banner_dismissed_until';
const SNOOZE_DAYS = 14;
const APP_STORE_URL = 'https://apps.apple.com/app/shopik/id6471020221';
const APP_SCHEME_URL = 'shopik://';

function isIOS() {
  const ua = window.navigator.userAgent || '';
  const isAppleTouch = /iPhone|iPad|iPod/.test(ua)
    // iPadOS 13+ reports as Mac; catch it via touch support.
    || (ua.includes('Macintosh') && navigator.maxTouchPoints > 1);
  return isAppleTouch;
}

function isDismissed() {
  const until = window.localStorage.getItem(DISMISS_KEY);
  return until && Date.now() < Number(until);
}

export default function AppSmartBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (isIOS() && !isDismissed()) {
        setVisible(true);
      }
    } catch (e) {
      // localStorage can throw in some private-browsing contexts; just skip the banner.
    }
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    try {
      const until = Date.now() + SNOOZE_DAYS * 24 * 60 * 60 * 1000;
      window.localStorage.setItem(DISMISS_KEY, String(until));
    } catch (e) {}
    setVisible(false);
  };

  const openApp = () => {
    // Try the app first; if it's not installed, iOS just no-ops and the
    // customer stays on this page (no fallback needed beyond the App Store link below).
    window.location.href = APP_SCHEME_URL;
  };

  return (
    <div className="app-smart-banner">
      <button className="app-smart-banner-close" onClick={dismiss} aria-label="Dismiss">
        &times;
      </button>
      <img src="/images/logo.png" alt="" className="app-smart-banner-logo" />
      <div className="app-smart-banner-text">
        <div className="app-smart-banner-title">Shopik</div>
        <div className="app-smart-banner-subtitle">Continue in the app</div>
      </div>
      <button className="app-smart-banner-open" onClick={openApp}>Open</button>
      <a
        className="app-smart-banner-get"
        href={APP_STORE_URL}
        target="_blank"
        rel="noreferrer"
      >
        Get
      </a>
    </div>
  );
}
